import type { ComponentPropsWithoutRef, FC } from 'react';
import React from 'react';
import styled, { css, keyframes } from 'styled-components';

import type { DotProps } from './Dot';
import {
  Dot,
} from './Dot';

const pulse = ({
  color,
  size,
}: DotProps) => keyframes`
  0% {
    box-shadow: 0 0 0 0 ${color};
    opacity: 0.5;
  }

  70% {
    box-shadow: 0 0 0 ${0.5 * size}px ${color};
    opacity: 0;
  }

  100% {
    box-shadow: 0 0 0 0 ${color};
    opacity: 0;
  }
`;

const BackgroundDot = styled(Dot)<DotProps>(({
  color,
  size,
}) => css`
  position: absolute;
  top: 0;
  left: 0;
  animation: ${pulse({ color, size })} 2s infinite;

  &:hover {
    animation: none;
  }
`);

const Wrapper = styled.div`
  display: inline-flex;
  position: relative;
`;

type Props = ComponentPropsWithoutRef<'div'> & {
  color?: string;
  shouldPulse?: boolean;
  size?: number;
};

export const PulseDot: FC<Props> = ({
  color = 'var(--cl-background-default)',
  shouldPulse = true,
  size = 12,
  ...rest
}) => (
  <Wrapper {...rest}>
    <Dot
      color={color}
      size={size}
    />
    {shouldPulse && (
      <BackgroundDot
        color={color}
        size={size}
      />
    )}
  </Wrapper>
);

export default PulseDot;
